
/* */
export const getAccountId = state => state.account.accountId;

/* */
export const getAccount = state => state.account.account;

/* */
export const getAccountLoading = state => state.account.accountLoading;

/* */
export const getCalleridRequest = state => state.account.calleridRequest;

/* */
export const getInvoice = state => state.account.invoice;

/* */
export const getInvoiceOpen = state => state.account.invoiceOpen;

/* */
export const getPaymentMethods = state => state.account.paymentMethods;

/* */
export const getStoredPaymentOpen = state => state.account.storedPaymentOpen;

/* */
export const getSubmittingPayment = state => state.account.submittingPayment;

/* */
export const getAutopayEnrollOpen = state => state.account.autopayEnrollOpen;

/* */
export const getSubmittingAutopayEnroll = state => state.account.submittingAutopayEnroll;

export const getCallSummaryStats = state => state.account.callSummaryStats;

export const getCallVolumes = state => state.account.callVolumes;

export const getContactInsights = state => state.account.contactInsights;

export const getTasksByInvoice = state => state.account.tasksByInvoice;

/* */
export const getInvoiceId = state => state.account.invoiceId;

export const getSelInvoice = state => state.account.selInvoice;

export const getWebLeads = state => state.account.chats;


/* */
export const getPaymentMethod = state => state.account.paymentMethod;

/* */
export const getAddPaymentMethodOpen = state => state.account.addPaymentMethodOpen;

/* */
export const getAddingPaymentMethod = state => state.account.addingPaymentMethod;

/* */
export const getUpdatePaymentMethodOpen = state => state.account.updatePaymentMethodOpen;

/* */
export const getUpdatePaymentMethod = state => state.account.updatePaymentMethod;

/* */
export const getSavingPaymentMethod = state => state.account.savingPaymentMethod;

/* */
export const getPlaidLinkToken = state => state.account.plaidLinkToken;

/* */
export const getPlaidAuthResponse = state => state.account.plaidAuthResponse;

/* */
export const getAddBankAccountOpen = state => state.account.addBankAccountOpen;

/* */
export const getAddingBankAccount = state => state.account.addingBankAccount;

/* Surcharge Functions */
export const getQueryingSurcharge = state => state.account.queryingSurcharge;
export const getSurchargeQueried = state => state.account.surchargeQueried;
export const getShowPaymentConfirmation = state => state.account.showPaymentConfirmation;
export const getOkToSubmitPayment = state => state.account.okToSubmitPayment;
export const getSurchargeObject = state => state.account.surchargeObject;

/* */
export const getPhoneNumberInsights = state => state.account.phoneNumberInsights;

/* */
export const getBillingEmails = state => state.account.billingEmails;
